<template lang="pug">
.VprProgressComponent
  ui-loader(v-if="isLoading")
  template(v-else)
    .items
      ui-child-item.item(
        v-if="items.length"
        v-for="(childVpr, index) in items"
        :key="childVpr.userItem.id"
        :child-item="childVpr"
        @action:click-on-item="onVprClick(childVpr.userItem.id)"
      )
      .emptyWrapper(
        v-else
        @click="onEmptyClick"
      )
        .iconWrapper
          ui-svg-icon.icon(
            name="plus"
          )
        .title  У вас ещё нет купленных ВПР, перейдите в витрину

</template>

<script>
import ChildVprListController from '@/controllers/ChildVpr/ChildVprListController'
import { inject, watch } from '@vue/runtime-core'

export default {
  setup () {
    const store = inject('store')
    const { items, childVprListRequest, isLoading } = ChildVprListController()

    watch(() => store.user.selectedChild.id, (childId) => { childVprListRequest(childId) }, { immediate: true })

    return {
      items,
      isLoading
    }
  },
  methods: {
    onEmptyClick () {
      this.$router.push({ name: 'Catalog' })
    },
    onVprClick (vprId) {
      this.$router.push({ name: 'VprContents', params: { id: vprId } })
    }
  }

}
</script>

<style lang="sass" scoped>
.VprProgressComponent
  > .items
    display: grid
    grid-template-columns: repeat(3, 1fr)
    grid-template-rows: minmax(150*$u, 1fr)
    grid-gap: 7.5*$u
    margin-bottom: 20px
    &:last-child
      margin-bottom: 0

    @media (max-width: $XXXLWidth)
      grid-template-columns: repeat(2, 1fr)
    @media (max-width: $padWidth)
      grid-gap: 5*$u
    @media (max-width: 748px)
      grid-template-columns: repeat(1, 1fr)

    > .emptyWrapper
      border-radius: $brL
      background-color: $cWhite
      box-shadow: 0 1.5*$u $cDarkBackground
      display: flex
      flex-flow: column
      align-items: center
      justify-content: center
      padding: 5*$u 10*$u
      cursor: pointer

      > .iconWrapper
        width: 30*$u
        height: 30*$u
        border-radius: 99em
        background-color: $cGrey
        padding: 9.5*$u
        margin-bottom: 10*$u

        > .icon
          color: $cDarkGrey

      > .title
        @include font('t18-regular')
        color: $cDarkGrey
        text-align: center

      @media (max-width: $padWidth)
        > .iconWrapper
          width: 25*$u
          height: 25*$u
          padding: 8*$u
          margin-bottom: 8*$u

</style>
